// utils/fileDownload.js
import { toast } from 'react-toastify'; // hoặc thư viện toast bạn đang dùng
 
/**
* Utility function để download file từ server
* @param {string} fileId - ID của file cần download
* @param {string} fileName - Tên file để lưu (optional)
* @param {function} onSuccess - Callback khi download thành công (optional)
* @param {function} onError - Callback khi có lỗi (optional)
* @returns {Promise<boolean>} - true nếu thành công, false nếu thất bại
*/
export const downloadFile = async (fileId:any, fileName:any = null, onSuccess:any = null, onError:any = null) => {
  try {
    const checkResponse = await fetch(
      `${process.env.REACT_APP_API_URL || 'http://localhost:7000/'}/resources/getfile/${fileId}`,
      {
        method: 'GET',
        credentials: 'include',
      }
    );
 
    if (!checkResponse.ok) {
      let messageError = '';
      if (checkResponse.status === 400) {
        messageError = 'File tải xuống có đuôi file không hợp lệ';
      } else if (checkResponse.status === 404) {
        messageError = 'Đường dẫn file không tìm thấy';
      } else {
        messageError = 'Có lỗi xảy ra khi tải file';
      }
 
      toast.error(messageError);
      if (onError) onError(messageError, checkResponse.status);
      return false;
    }
 
    const blob = await checkResponse.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || `file_${fileId}`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
 
    if (onSuccess) onSuccess();
    return true;
  } catch (error:any) {
    console.error('Download error:', error);
    toast.error('Có lỗi xảy ra khi tải file');
    if (onError) onError(error.message);
    return false;
  }
};
 
/**
* Utility function để mở file trong tab mới để view
* @param {string} fileId - ID của file cần view
*/
export const viewFileInNewTab = (fileId:any) => {
  window.open(
    `${process.env.REACT_APP_API_URL || 'http://localhost:7000/'}/resources/getfile/${fileId}`,
    '_blank'
  );
};